import { payersApi, personsApi } from "@api";
import { useSession } from "@hooks/useSession";
import { queriesNotifications, queriesPayers } from "@query";
import { useWSMutation, WSMutationConfig } from "@ws-react-query";

import { selectorPersonDisplayName } from "../../../../../../shared/selectors/selectorPersonDisplayName";
import { buildTaxInformationConsent } from "../../../../../../shared/utils/buildTaxInformationConsent";
import { WSServiceError } from "../../../../../../utils/serviceHelper";

export const useMutationSubmit = (config?: WSMutationConfig<void>) => {
  const { personId } = useSession();

  return useWSMutation<any, WSServiceError, string>(
    async (payerId: string) => {
      // TODO(v3): per-payer tax-information share. `payerId` here is a v3 `Payer.id`,
      // read straight off the `getPayer` cache by the opener.
      // INTERIM consent: signature derived from the payee's on-file legal name —
      // DOUBLE-CHECK pending Legal sign-off; see buildTaxInformationConsent.
      const person = await personsApi.getPerson({ personId });
      const consent = buildTaxInformationConsent({
        signature: selectorPersonDisplayName(person)
      });

      return payersApi.shareTaxInformation({
        payerId,
        payerShareTaxInformationRequest: { consent }
      });
    },
    {
      dependencies: [queriesNotifications.listNotifications.queryKeyBase],
      awaitDependencies: (result, payerId) => [
        queriesPayers.getPayer.getQueryKey({ payerId })
      ],
      ...config
    }
  );
};
